import React, { useMemo } from 'react'
import { castArray, concat, get, isArray } from 'lodash-es'
import { ErrorBoundary } from 'react-error-boundary'
import clsx from 'clsx'
import Table from '../../tables'
import WebBasicLayouts from '../../forms/web/layouts'

const fileterSystemFields = (fields) => {
  if (!fields) {
    return []
  }

  return fields.filter((field) => {
    return field && !['system'].includes(field.group) && !field.hidden
  })
}

const RenderTable = ({ value, defs }) => {
  console.log(defs, 'defsdefsdefsdefs')
  const { refTbdefs, multiple } = defs
  const { fields, tbSlug } = refTbdefs || {}
  const tbData = castArray(value)

  const showFields = useMemo(() => {
    let arr = []
    if (fields) {
      arr = concat(
        fields.filter((v) => v.type === 'identifier'),
        fileterSystemFields(fields)
      )
    }

    // 大连的需求（写死）
    if (tbSlug === 'anjianliebiao_ce37c543_a334_4e23_aaef_dbb26bb60930') {
      return arr.filter((v) => v.slug !== 'specialUcaseExtStatus')
    }

    return arr
  }, [fields])

  const config = useMemo(() => {
    const arr = showFields.map((v) => {
      return { slug: v.slug, showType: 'show' }
    })
    return { fields: arr }
  }, [showFields])

  return (
    <div className={clsx(multiple && 'h-96', !multiple && 'h-32', 'w-full')}>
      <div className="w-full h-full relative hidden md:block">
        <Table
          fields={showFields}
          tbData={tbData}
          config={config}
          isRenderOperateTable={false}
        />
      </div>
    </div>
  )
}

const RenderLayouts = ({ value, defs }) => {
  const currentData = isArray(value) ? value[0] : value
  return (
    <ErrorBoundary fallback={<div>详情信息渲染错误</div>}>
      <WebBasicLayouts
        fields={get(defs, 'refTbdefs.fields', [])}
        layouts={defs.layouts || {}}
        data={currentData || {}}
        hiddenNavMenu
      />
    </ErrorBoundary>
  )
}

const RefBlock = function ({ value, defs }) {
  const { layouts } = defs
  if (layouts) {
    return <RenderLayouts value={value} defs={defs} />
  }
  return <RenderTable value={value} defs={defs} />
}

export default RefBlock
